<template>
  <section class="info">
    <!-- Title -->
    <div class="info__title">
      {{ $t('info_1') }}
    </div>

    <!-- Button -->
    <router-link :to="{ name: 'about' }">
      <button-view variant="primary">
        {{ $t('button_2') }}
      </button-view>
    </router-link>
  </section>
</template>

<script>
export default {
  name: 'Info',

  components: {
    ButtonView: () => import('@/components/button/button-view')
  }
};
</script>

<style lang="scss" src="@/assets/components/info/info-view.scss"></style>



// WEBPACK FOOTER //
// info-view.vue